import { FC } from 'react';

import { useTranslations } from '../hooks/useTranslations.ts';
import { translationKeys } from '../translations/translationKeys.ts';
import ThankYouScreenWrapper, { ThankYouScreenProps } from './ThankYouScreenWrapper.tsx';

const ThankYouScreenAddOn: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();
  return (
    <ThankYouScreenWrapper {...props} title={translate(translationKeys.THANK_YOU_TITLE)} disableOnMobile>
      <div>
        <div className="w-full mb-6">
          <p className="text-base leading-6 text-content-secondary">
            {translate(translationKeys.THANK_YOU_ADDON_BODY)}
          </p>
        </div>

        <div className="w-full p-4 bg-intent-info-5 border border-intent-info-4 rounded-lg">
          <p className="text-sm leading-5 text-intent-info-2 font-medium mb-2">
            {translate(translationKeys.THANK_YOU_ADDON_OPTIONS_TITLE)}
          </p>
          <p className="text-sm leading-5 text-intent-info-1 mb-3">
            {translate(translationKeys.THANK_YOU_ADDON_OPTIONS_BODY_1)}
          </p>
          <p className="text-sm leading-5 text-intent-info-1 mb-3">
            {translate(translationKeys.THANK_YOU_ADDON_OPTIONS_BODY_2)}
          </p>
          <p className="text-sm leading-5 text-intent-info-1">
            {translate(translationKeys.THANK_YOU_ADDON_OPTIONS_BODY_3)}
          </p>
        </div>
      </div>
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenAddOn;
